<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MIT -->
<div class="offcanvas-container">
  <div class="close-button-box cursor-pointer" (click)="onCloseModal()">
    <i class="fal fa-times"></i>
  </div>
  <div class="main-content-box">
    <div>
      <lfx-employee-info-card
        [lfUserId]="employeeId"
        [memberId]="employeeId"
        [organization]="organization"
        [otherEmails]="employee?.otherEmailAddress || []"
        [defaultEmployeeObject]="defaultEmployeeObject"
        [hasUsername]="employeeHasUsername"
        [hasDashboardAccess]="employeeHasDashboardAccess"
      ></lfx-employee-info-card>
    </div>

    <div ngbAccordion class="profile-accordion" #accordion="ngbAccordion">
      <!-- Activity -->
      <div ngbAccordionItem="activity">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Activity</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <lfx-employee-activity-card
                [userId]="employeeId"
                [defaultFilter]="options?.activity?.defaultFilter"
                [projectId]="projectId"
                [initialTimeRange]="initialTimeRange"
              ></lfx-employee-activity-card>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Access -->
      <div ngbAccordionItem="access" *ngIf="employee">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Access</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div
                class="d-flex justify-content-between align-items-center"
                *ngIf="employee | dashboardAccess as access"
              >
                <div class="d-flex align-items-center">
                  <div class="access-title">Current Access</div>
                  <div class="lf-pills-container">
                    <span
                      [class.lf-pill-dark]="access === dashboardAccess.Admin"
                      [class.lf-pill]="access !== dashboardAccess.Default"
                      >{{ access }}</span
                    >
                  </div>
                </div>
                <ng-container *ngIf="canMakeUpdates$ | async">
                  <div
                    class="lf-link font-14"
                    *ngIf="
                      access === dashboardAccess.Admin ||
                      access === dashboardAccess.Viewer
                    "
                    (click)="openEditAccess()"
                  >
                    <i class="fal fa-pen"></i> Edit
                  </div>
                </ng-container>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Key Contacts -->
      <div ngbAccordionItem="key-contacts" *ngIf="employee && keyContactsData.length">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Key Contacts ({{ keyContactsData.length }})</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="d-flex" *ngIf="canMakeUpdates$ | async">
                <div class="font-14 margin-left-auto">
                  To change any key contact, visit the foundation membership details page
                </div>
              </div>
              <lfx-new-table
                [columns]="keyContactsColumns"
                [data]="keyContactsData"
                [version]="2"
              ></lfx-new-table>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Committees -->
      <div ngbAccordionItem="committees" *ngIf="employee && committeesData.length">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Committees ({{ committeesData.length }})</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <div class="d-flex" *ngIf="canMakeUpdates$ | async">
                <div class="font-14 margin-left-auto">
                  To change any role or board seat, visit the foundation membership details page
                </div>
              </div>
              <lfx-new-table
                [columns]="committeesColumns"
                [data]="committeesData"
                [version]="2"
              ></lfx-new-table>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Contributor -->
      <div ngbAccordionItem="contributor" *ngIf="allContributions.length">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton>Contributor ({{ allContributions.length }})</button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <ng-template>
              <lfx-new-table
                [columns]="contributorColumns"
                [data]="contributorData"
                [version]="2"
              ></lfx-new-table>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <lfx-section-footer></lfx-section-footer>
  </div>
</div>

<ngx-spinner></ngx-spinner>

<ng-template #committeeProject let-row="row">
  <div class="committee-name-section">
    <div
      class="committee-name"
      [title]="row.project"
      [class.lf-link]="isProjectMembership(row.projectId)"
      (click)="isProjectMembership(row.projectId) && openProjectPage(row.projectId)"
    >
      {{ row.project }}
    </div>
    <div class="lf-pills-container">
      <span
        class="lf-pill"
        placement="bottom"
        [ngbPopover]="row.committeeName.length > 27 ? row.committeeName : ''"
        triggers="mouseenter:mouseleave"
      >
        {{ row.committeeName | ellipsis: 27 }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #projectNameTemplate let-row="row">
  <div
    class="project-name"
    [title]="row.project.text"
    [class.lf-link]="isProjectMembership(row.projectId)"
    (click)="isProjectMembership(row.projectId) && openProjectPage(row.projectId)"
  >
    {{ row.project.text }}
  </div>
</ng-template>

<ng-template #contributorRole let-row="row">
  <div class="contact-type-pill">
    {{ row.role }}
  </div>
</ng-template>

<ng-template #contributorProjects let-row="row">
  <ng-container *ngFor="let project of row.projects">
    <div class="project">{{ project.parentProjectName }}</div>
    <ul>
      <li *ngFor="let subproject of project.subProjects">
        {{ subproject.projectName }}
      </li>
    </ul>
  </ng-container>
</ng-template>
